// src/components/profile/Body_forgot_password.js
import React, { useState } from 'react';
import '../../styles/profile/forgot_pass.css';

function Body_forgot_password() {
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus(null);

        try {
            const res = await fetch('https://nurleder.de/api/forgot-password/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ email }),
                credentials: 'omit' // wichtig: kein Cookie → kein CSRF
            });

            const data = await res.json();

            if (res.ok) {
                setStatus({
                    success: true,
                    message: data.message || 'E-Mail zum Zurücksetzen wurde gesendet.'
                });
            } else {
                setStatus({
                    success: false,
                    message: data.error || 'Ein Fehler ist aufgetreten.'
                });
            }
        } catch (err) {
            console.error(err);
            setStatus({
                success: false,
                message: 'Netzwerkfehler. Bitte versuchen Sie es erneut.'
            });
        }
    };

    return (
        <div className="forgot-container">
            <form className="forgot-form" onSubmit={handleSubmit}>
                <h2>Passwort vergessen</h2>

                <input
                    type="email"
                    placeholder="Ihre E-Mail-Adresse"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />

                <button type="submit">Zurücksetzen senden</button>

                {status && (
                    <p className={`status-message ${status.success ? 'success' : 'error'}`}>
                        {status.message}
                    </p>
                )}
            </form>
        </div>
    );
}

export default Body_forgot_password;
